const dateFields = ['documentIssueDate', 'documentExpiryDate', 'birthDate'];

function validDate(value) {
    if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
    const parsed = new Date(`${value}T00:00:00.000Z`);
    return !Number.isNaN(parsed.getTime()) && parsed.toISOString().slice(0, 10) === value;
}

export function prejoiningWarnings(answers, now = new Date()) {
    const warnings = {};
    // Compare calendar dates in the candidate's local timezone, without rounding ages in days.
    const monthDay = `${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    const today = `${now.getFullYear()}-${monthDay}`;
    const adultBirthDate = `${now.getFullYear() - 18}-${monthDay}`;
    const noExpiry = answers.documentType === 'NIC' && answers.documentNoExpiry;
    if (/\p{N}/u.test(answers.fullLegalName || '')) {
        warnings.fullLegalName = 'Please check your NIC / passport full name. It should not contain numbers.';
    }
    for (const key of dateFields) {
        if (key === 'documentExpiryDate' && noExpiry) continue;
        if (answers[key] && !validDate(answers[key])) warnings[key] = 'Please check this date. Enter a valid date.';
    }
    if (validDate(answers.documentIssueDate) && answers.documentIssueDate > today) {
        warnings.documentIssueDate = 'Please check the NIC / passport issue date. It should be today or in the past.';
    }
    if (!noExpiry && validDate(answers.documentIssueDate) && validDate(answers.documentExpiryDate)
        && answers.documentExpiryDate <= answers.documentIssueDate) {
        warnings.documentExpiryDate = 'Please check the NIC / passport expiry date. It should be after the issue date.';
    }
    if (validDate(answers.birthDate) && answers.birthDate > adultBirthDate) {
        warnings.birthDate = 'Please check your date of birth. This date indicates you are under 18; it should be at least 18 years before today.';
    }
    return warnings;
}
